import { createI18n } from 'vue-i18n';

// Определите переводы для каждого языка
const messages = {
  en: {
    welcome: 'Welcome to AeroCommander operations center',
    register: 'Register',
    login: 'Login',
    main: 'Main',
    videoStream: 'VideoStream',
    feedback: 'Feedback',
    settings: 'Settings',
    contactUs: 'Contact Us',
    enterStreamName: 'Enter the stream name',
    username: 'Username',
    password: 'Password',
    startStream: 'Start Stream',
    enterPassword: 'Enter password',
    enterUsername: 'Enter username',
    select: 'Select UAV',
    logout: 'Logout',
    server : 'Server',
    noAccess: 'Access Denied',
    admin: 'Admin',
    status: 'Status',
    actions: 'Action',
    adminDashboard: 'Admin Dashboard',
    user: 'User',
    passwordChanged: 'Password Changed',
    passwordChangedText: 'Your password has been changed successfully. You can now log in with your new password.', 
    changePassword: 'Change Password',
    changePasswordText: 'Enter your current password and a new password. Your password must be at least 8 characters long.',
    passwordChangedTitle: 'Password Changed',
    passwordChangedMessage: 'Your password has been changed successfully. You can now log in with your new password.',
    passwordChangedError: 'Failed to change password',
    passwordChangedErrorText: 'Failed to change password. Please try again.',
    passwordChangedErrorTitle: 'Failed to change password',
    passwordChangedErrorMessage: 'Failed to change password. Please try again.',
    resetPassword: 'Reset Password',
    role: 'Role',
    online: 'Online',
    offline: 'Offline',
    onlineUsers: 'Online Users',
    update: 'Update',
    delete: 'Delete',
  },
  ru: {
    welcome: 'Добро пожаловать в диспетчерский центр AeroCommander',
    login: 'Вход',
    register: 'Регистрация',
    main: 'Главная',
    videoStream: 'ВидеоСтрим',
    feedback: 'Обратная связь',
    settings: 'Настройки',
    contactUs: 'Свяжитесь с нами',
    enterStreamName: 'Введите имя потока',
    username: 'Имя пользователя',
    password: 'Пароль',
    startStream: 'Начать трансляцию',
    enterPassword: 'Введите пароль',
    enterUsername: 'Введите имя пользователя',
    select: 'Выберите модель БПЛА',
    logout: 'Выход',
    server : 'Сервер',
    noAccess: 'Доступ запрещен',
    admin: 'Админ',
    status: 'Статус',
    actions: 'Действия',
    adminDashboard: 'Панель администратора',
    user: 'Пользователь',
    passwordChanged: 'Пароль изменен',
    passwordChangedText: 'Ваш пароль был успешно изменен. Теперь вы можете войти с новым паролем.',
    changePassword: 'Изменить пароль',
    changePasswordText: 'Введите ваш текущий пароль и новый пароль. Ваш пароль должен содержать не менее 8 символов.',
    passwordChangedTitle: 'Пароль изменен',
    passwordChangedMessage: 'Ваш пароль был успешно изменен. Теперь вы можете войти с новым паролем.',
    passwordChangedError: 'Не удалось изменить пароль',
    passwordChangedErrorText: 'Не удалось изменить пароль. Пожалуйста, попробуйте еще раз.',
    passwordChangedErrorTitle: 'Не удалось изменить пароль',
    passwordChangedErrorMessage: 'Не удалось изменить пароль. Пожалуйста, попробуйте еще раз.',
    resetPassword: 'Сбросить пароль',
    role: 'Роль',
    online: 'Онлайн',
    offline: 'Оффлайн',
    onlineUsers: 'Онлайн пользователи',
    update: 'Обновить',
    delete: 'Удалить',
  },
  kz: {
    welcome: 'AeroCommander диспетчерлік орталығына қош келдіңіз',
    login: 'Кіру',
    register: 'Тіркелу',
    main: 'Басты бет',
    videoStream: 'Бейне ағыны',
    feedback: 'Кері байланыс',
    settings: 'Параметрлер',
    contactUs: 'Бізбен хабарласыңыз',
    enterStreamName: 'Ағын атауын енгізіңіз',
    username: 'Пайдаланушы аты',
    password: 'Құпия сөз',
    startStream: 'Ағынды бастау',
    enterPassword: 'Құпия сөзді енгізіңіз',
    enterUsername: 'Пайдаланушы атын енгізіңіз',
    select: 'Ұшқышсыз ұшақ таңдаңыз',
    logout: 'Шығу',
    server : 'Сервер',
    noAccess: 'Кіруге тыйым салынған',
    admin: 'Админ',
    status: 'Қалыптау',
    actions: 'Қері',
    adminDashboard: 'Админ панели',
    user: 'Пайдаланушы',
    passwordChanged: 'Құпия сөз сәтті',
    passwordChangedText: 'Ваш пароль был успешно изменен. Теперь вы можете войти с новым паролем.',
    changePassword: 'Құпия сөзді өзгерту',
    changePasswordText: 'Құпия сөзді енгізіңіз. Ваш пароль должен содержать не менее 8 символов.',
    passwordChangedTitle: 'Құпия сөз сәтті',
    passwordChangedMessage: 'Ваш пароль был успешно изменен. Теперь вы можете войти с новым паролем.',
    passwordChangedError: 'Құпия сөзді өзгертілмеді',
    passwordChangedErrorText: 'Құпия сөзді өзгертілмеді. Пожалуйста, попробуйте еще раз.',
    passwordChangedErrorTitle: 'Құпия сөзді өзгертілмеді',
    passwordChangedErrorMessage: 'Құпия сөзді өзгертілмеді. Пожалуйста, попробуйте еще раз.',
    resetPassword: 'Құпия сөзді жіберу',
    role: 'Рөл',
    online: 'Онлайн',
    offline: 'Оффлайн',
    onlineUsers: 'Онлайн пайдаланушылар',
    update: 'Жаңарту',
    delete: 'Жою',
  }
};

// Создайте экземпляр i18n
const i18n = createI18n({
  locale: 'en', // Установите текущий язык
  fallbackLocale: 'en', // Язык по умолчанию
  globalInjection: true,
  messages, // Добавьте переводы
});

export default i18n;
